import React from 'react'
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import Typewriter from "typewriter-effect";

const HeaderMarketing = () => {
  return (
    <header className="top-0 z-30  py-4 px-5 lg:px-10 w-full">
          <nav className="grid grid-cols-2 lg:grid-cols-3">
            <div className="flex items-center ">
              <Link to="/">
                <img
                  src={logo}
                  alt="logo"
                  className="w-20 h-13 cursor-pointer"
                />
              </Link>
            </div>

            <div className="hidden lg:flex lg:flex-grow lg:items-center gap-2 px-[2.5em] text-lyellow text-3xl lg:w-[20em] ml-[-0.8em]">
              <span className="">Participate and Win:</span>
              <span className="text-white text-2xl">
                <Typewriter
                  options={{
                    strings: ["Rewards", "Token", "USDT"],
                    autoStart: true,
                    loop: true,
                  }}
                />
              </span>
            </div>

            <div className="flex items-center justify-end">
              <button className="bg-lyellow text-md font-semibold py-2 px-[3.6em] hover:bg-[#1d2226] hover:text-white transition ease-in duration-200 rounded-xl">
                Connect
              </button>
            </div>
          </nav>
        </header>
  )
}

export default HeaderMarketing